import isEmpty from 'lodash/isEmpty';
import values from 'lodash/values';
import moment from 'moment';
import { AfterContentInit, Component, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { NgbDateStruct, NgbDatepickerNavigateEvent } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'ui-datepicker-popup',
  templateUrl: './ui-datepicker-popup.component.html',
  styleUrls: ['./ui-datepicker-popup.component.scss']
})
export class UiDatepickerPopupComponent implements AfterContentInit {
  public ngbModel: NgbDateStruct;

  @Input() disabled: boolean;
  @Input() minDate?: Date;
  @Input() placeholder: string;
  @Input() placement: string;
  @Input() maxDate?: Date;
  @Input() controlName: string = Math.random() + '';

  @Input()
  public get model() {
    try {
      return this._fromDateObjectToDate(this.ngbModel);
    } catch (err) {
      console.warn(JSON.stringify(err));
    }
  }

  public set model(date: Date) {
    try {
      this.ngbModel = this._toDateObject(date);
    } catch (err) {
      console.warn(JSON.stringify(err));
    }
  }

  @Output() modelChange = new EventEmitter<Date>();
  @Output() onScheduleChange = new EventEmitter<any>();
  @Output() onInactiveChange = new EventEmitter<any>();
  @Output() onContextInit = new EventEmitter<any>();

  @ViewChild('dp', { static: true }) dp;

  @HostListener('document:click', ['$event.target'])
  handleOutsideClick(target: EventTarget | null) {
    if (!(target instanceof HTMLElement)) {
      return;
    }
    if (!this.dp.isOpen() || target.id == this.controlName
      || (target.offsetParent && target.offsetParent.localName.includes('ngb-datepicker'))
      || !(target.parentElement && target.parentElement.parentElement &&
        !target.parentElement.parentElement.localName.includes('ngb-datepicker'))) {
      return;
    }

    if (this.dp.isOpen() && target.id != this.controlName) {
      this.dp.close();
    }
  }

  ngAfterContentInit(): void {
    this.onContextInit.emit(this.dp);
  }

  public onDateChanged(ngbModel: NgbDateStruct) {
    try {
      let nativeDate = this._fromDateObjectToDate(ngbModel);
      this.modelChange.emit(nativeDate);
    } catch (err) {
      console.warn(JSON.stringify(err));
    }
  }

  public onClick(e) {
    this.dp.open();
  }

  public checkModel() {
    return !isEmpty(this.ngbModel) && values(this.ngbModel).every(Boolean);
  }

  public onMonthUpdated(changes: NgbDatepickerNavigateEvent) {
    if (!changes.current ||
      (changes.next.month === changes.current.month &&
        changes.next.year === changes.current.year)) {
      return;
    }
  }

  public getNgbDate(date: Date) {
    return date ? this._toDateObject(date) : null;
  }

  public isToday(date: NgbDateStruct) {
    let now = this._toDateObject(new Date());
    return now.year === date.year &&
      now.month === date.month &&
      now.day === date.day;
  }

  _fromDateObjectToDate(obj: any): Date {
    return moment()
      .year(obj.year)
      .month(obj.month - 1)
      .date(obj.day)
      .toDate();
  }

  _toDateObject = (date: Date) => {
    const mDate = moment(date);
    return {
      day: mDate.date(),
      month: mDate.month() + 1,
      year: mDate.year()
    };
  };

}
